import { Component, OnInit, ChangeDetectorRef, OnDestroy, HostBinding, Inject, ViewChild, AfterViewInit, ViewContainerRef, DoCheck, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import { AuthenticationStateService } from '@app/core/services/authentication-state.service';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UsersService } from '@app/services/users/users.service';
import { ActivatedRoute } from "@angular/router";
import { distinctUntilChanged, filter, first, skipWhile, take, tap } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import {
  BreakpointObserver,
  BreakpointState,
} from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { SideNavService } from '@app/services/side-nav/side-nav.service';
import { ImageUploadService } from '@app/services/image-upload/image-upload.service';
import { BillingService, BillingState } from '@app/services/billing/billing.service';
import * as SettingsActions from '@app/modules/settings/store/actions/settings.actions';
import { Store } from '@ngrx/store';
import * as CoreActions from '@app/core/store/core.action';
import { NAV_OVERLAY_QUERIES } from '@app/core/layout/nav-breakpoints';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import * as ImageActions from '@app/modules/image/store/actions/image.actions';
import { selectImageProfleImageState } from '@app/modules/image/store/selectors/image.selectors';
import { selectCoreState, selectIsNavOpen, selectIsNavCollapsed, selectMeState, selectTitle } from '@app/core/store/core.selectors';
import { JwtService } from '@app/core/services/jwt.service';
import * as IntegrationsActions from '@app/modules/integrations/store/actions/integrations.actions'
import * as ProductActions from '@app/modules/products/store/actions/products.actions';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';

import { locName$ } from '@app/modules/organization/branding/branding.component';
import { IUser } from '@app/models/user.interface';
import * as UserActions from '@app/modules/users/store/actions/user.actions';
import { loadMostRecent } from '@app/modules/counts/store/actions/counts.actions';
import { loadProducts } from '@app/modules/products/store/actions/products.actions';
import { UserEditComponent } from '@app/modules/users/user-edit/user-edit.component';
import { PANEL_VERSION } from '@app/core/version';
import { SupportContactDialogComponent } from '@app/modules/users/support-contact/support-contact-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MobileAppPromoComponent, MOBILE_APP_PROMO_DISMISSED_KEY } from '@app/shared/components/mobile-app-promo/mobile-app-promo.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})
export class ContentLayoutComponent implements OnInit, AfterViewInit {
  localName$: Observable<string>; // Declara la propiedad como un Observable
  @HostBinding('class') className = '';
  @ViewChild('snav') sidenav: MatSidenav;
  @ViewChild(MatSidenavContainer) sidenavContainer: MatSidenavContainer;

  public opened: boolean = true;
  public currentUser;
  public isHome$: boolean = false;
  public title$: string = null;
  public imageUploadSub: Subscription;
  public user;
  public panelVersion = PANEL_VERSION;
  public toggleControl = new FormControl(true);
  public changeSize = true;
  public selectedItem: string = '';
  public assetModule: number;
  public countingModule: number;
  public profileUrl = '';
  public show_location: boolean;
  public avatarUrl: string = '';
  // Profile image (when set) for the sidebar user avatar; falls back to initials.
  public profileImage$ = this.store$.select(selectImageProfleImageState);
  public isSideNavOpen$: boolean = true;
  // Mini-rail (collapsed) state — sidebar stays visible but narrow (icons only).
  public isCollapsed$: boolean = false;
  private isHandsetNow = false;

  // Getter for user initials (for avatar)
  get userInitials(): string {
    const firstName = this.user?.usrFirstName || '';
    const lastName = this.user?.usrLastName || '';
    return ((firstName.charAt(0) || '') + (lastName.charAt(0) || '')).toUpperCase() || 'U';
  }
  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(NAV_OVERLAY_QUERIES)
    .pipe(map((result: BreakpointState) => result.matches));
  public locationList: any;
  public countLocationsList: any;
  public showLocationsList: boolean = false;
  selectedLocation: number[] = [];
  selectedLocations: number[] = [];
  isAllSelected: boolean = false;

  @ViewChild('snav') drawer: any;
  @ViewChild('panel', { static: true }) private sidePanel: MatSidenav;
  @ViewChild('content', { static: true, read: ViewContainerRef }) private vcf: ViewContainerRef;
  @ViewChild('catContent', { static: true, read: ViewContainerRef }) private catVcf: ViewContainerRef;

  private mMediaChange$: Observable<MediaChange[]>;
  private navigationEndSubscription: Subscription;

  // Payment countdown shown while a trial sits inside its grace period
  public billingState$: Observable<BillingState | null>;

  constructor(
    public changeDetectorRef: ChangeDetectorRef,
    public media: MediaMatcher,
    private _mediaObserver: MediaObserver,
    public authenticationStateService: AuthenticationStateService,
    public router: Router,
    private location: Location,
    public _users: UsersService,
    public _acr: ActivatedRoute,
    private _cookieService: CookieService,
    private breakpointObserver: BreakpointObserver,
    public _sidenav: SideNavService,
    private _imageUpload: ImageUploadService,
    private store$: Store,
    private _jwt: JwtService,
    private route: ActivatedRoute,
    private _matDialog: MatDialog,
    private _translate: TranslateService,
    private _billing: BillingService,
  ) {
    this.locationList = [];
    this.billingState$ = this._billing.state$;
    this._billing.ensureState().subscribe();
    this.store$.dispatch(CoreActions.loadMe());
    this.store$.dispatch(SettingsActions.loadSettings());
    this.store$.dispatch(ImageActions.loadProfileImage());

    this.store$
    .select(selectCoreState)
    .pipe(
      filter((res) => res !== undefined && res !== null), 
      tap((res) => {
        this.show_location = res.show_location;
        
        if (res.me?.locName !== undefined) {
          let locID = parseInt(res.me?.locID, 10);
          this.selectedLocation = [locID];
          this.selectedLocations = res.me?.locIDs;
        }
       
      })
    )
    .subscribe();

    this.store$.dispatch(CountsActions.loadCounts({ active: 'invStartTS', direction: 'ASC', locations: this.selectedLocation  }))

    this.store$.select(selectMeState).pipe(
      skipWhile(res => res == null),
      take(1)
    ).subscribe((me) =>  {
      this.currentUser = me;
    });
    
    // Docked on desktop, closed overlay on a phone - re-applied every time the
    // window crosses the breakpoint. This used to stop after the first change
    // (take(2)), so a window that was narrowed and widened again kept a closed
    // sidebar in docked mode, where the menu button cannot reopen it.
    this.isHandset$.pipe(distinctUntilChanged()).subscribe((isHandset) => {
      this.isHandsetNow = isHandset;
      this.store$.dispatch(CoreActions.setIsSideNavOpen({ isSideNavOpen: !isHandset }));
    });


    this.store$.select(selectTitle).subscribe(title => this.title$ = title);
    this.navigationEndSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        distinctUntilChanged((prev: NavigationEnd, curr: NavigationEnd) => prev.urlAfterRedirects === curr.urlAfterRedirects),
      )
      .subscribe((event: NavigationEnd) => {
        // Check if homepage
        this.isHome$ = (this.router.url === "/");

        this.history.push(event.urlAfterRedirects);
      });
  }

  saveVariableValue() {
    localStorage.setItem('scroll', 'yes');
  }

  /**
   * Sends the admin to Stripe to settle the outstanding invoice.
   */
  public onManageBilling(): void {
    this._billing.createPortalSession().subscribe({
      next: (res) => {
        if (res?.url) {
          window.location.href = res.url;
        }
      }
    });
  }

  ngOnInit(): void {

    this.store$
      .select(selectCoreState)
      .pipe(
        filter((res) => res !== undefined && res !== null && res.me !== null), // Filter out undefined or null values of res
        tap((res) => {
          this.isSideNavOpen$ = res.isSideNavOpen;

          this.user = res.me;
          this.showLocationsList = false;

          //if (locName$.value == null && res.me?.locName !== undefined) {
          if (res.me?.locName !== undefined) {
            locName$.next(res.me?.locName);
          }

          this.localName$ = locName$;

          this.selectedLocation = [res.me?.locID];
          this.selectedLocations = res.me?.usrLocIDs;

          if(this.user && this.user.usrLocations != null){
            this.locationList = Object.entries(this.user.usrLocations);
            this.countLocationsList = this.locationList.length;
            if(this.countLocationsList > 0){
              this.showLocationsList=true;
            }
          }
          if(this.locationList.length>1){
            this.showLocationsList = true;
          }
          else{
            this.showLocationsList = false;
          }

          if(this.selectedLocations.length==this.locationList.length){
            this.isAllSelected = true;
          }

        })
      )
      .subscribe();

    this.store$.select(selectIsNavOpen).subscribe(isSideNavOpen => this.isSideNavOpen$ = isSideNavOpen);
    // Recalc content margins whenever collapse changes — no matter who triggered
    // it (the toggle button OR a navbar item expanding the rail) — so the page
    // shifts to match the new sidebar width.
    this.store$.select(selectIsNavCollapsed).subscribe(c => {
      this.isCollapsed$ = c;
      this.recalcContentMargins();
    });

    this.store$.select(selectSettingsState).pipe(
      skipWhile(settings => settings == null),
    ).subscribe((settings) => {
      this._users.onSetIslocUsesAssetModuleData(settings.locUsesAssetModule);
      this._users.onSetIslocUsesCountingModuleData(settings.locUsesCountingModule);
    });

    this.toggleControl.valueChanges.pipe(first()).subscribe((darkMode) => {
      const darkClassName = 'darkMode';
      this.className = darkMode ? darkClassName : '';
    });

    this.maybeShowMobileAppPromo();
  }

  private mobileAppPromoShown = false;

  private maybeShowMobileAppPromo(): void {
    if (this.mobileAppPromoShown) return;
    if (!this.isMobileDevice()) return;
    if (localStorage.getItem(MOBILE_APP_PROMO_DISMISSED_KEY) === '1') return;
    this.mobileAppPromoShown = true;
    this._matDialog.open(MobileAppPromoComponent, {
      width: '90vw',
      maxWidth: '420px',
      autoFocus: false,
      panelClass: 'mobile-app-promo-dialog'
    });
  }

  private isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  ngAfterViewInit() {

  }

  /*editUser():void {
  
    this._matDialog.open(UserEditComponent, {
      data:{
        id:this.currentUser.usrID
      },
      minWidth: '60vw',
      maxWidth: '800px',
      minHeight:'40vh',
      maxHeight: '80vh'
    })

  }*/

  ngOnDestroy(): void {
    if (this.navigationEndSubscription) {
      this.navigationEndSubscription.unsubscribe();
    }
  }

  onToggle() {
    // On mobile keep the full hide/show (overlay) behaviour. The store is the
    // one source of truth for it; the [opened] binding does the opening.
    // Toggling the drawer here as well used to fight the binding whenever the
    // two disagreed, so a tap could open and immediately close the sidebar.
    if (this.isHandsetNow) {
      this.store$.dispatch(CoreActions.setIsSideNavOpen({ isSideNavOpen: !this.drawer.opened }));
      return;
    }
    // On desktop the button toggles the mini-rail - unless the sidebar is not
    // there at all, in which case bringing it back is the only useful answer.
    if (!this.isSideNavOpen$) {
      this.store$.dispatch(CoreActions.setIsSideNavOpen({ isSideNavOpen: true }));
      this.recalcContentMargins();
      return;
    }
    this.store$.dispatch(CoreActions.setIsSideNavCollapsed({ isSideNavCollapsed: !this.isCollapsed$ }));
    this.recalcContentMargins();
  }

  // The drawer can close itself without asking (a backdrop tap on mobile).
  // Record that in the store, or the next menu tap starts from a state that is
  // no longer true: it asked for "closed" and nothing moved.
  onSidenavOpenedChange(opened: boolean): void {
    if (opened !== this.isSideNavOpen$) {
      this.store$.dispatch(CoreActions.setIsSideNavOpen({ isSideNavOpen: opened }));
    }
  }

  // Route titles whose page renders its own header (title + actions on one row),
  // so the generic page header above the outlet is suppressed for them.
  public selfHeaderPages: string[] = ['products', 'settings', 'inventoryCounts', 'finalized',
    'reports.totalonhand', 'reports.picked', 'reports.pickActivity', 'reports.received', 'reports.reorder', 'reports.assets', 'reports.serialized', 'tasks', 'roles', 'profile',
    'home'];

  // Called from the navbar (via store) to leave rail mode — e.g. clicking a
  // menu item that has a submenu while collapsed.
  expandSidebar() {
    this.store$.dispatch(CoreActions.setIsSideNavCollapsed({ isSideNavCollapsed: false }));
    this.recalcContentMargins();
  }

  // The rail width changes via CSS; Material sizes the content offset from the
  // drawer width, so ask it to remeasure after the class has applied.
  private recalcContentMargins() {
    setTimeout(() => this.sidenavContainer?.updateContentMargins(), 0);
  }

  openSupportContact(): void {
    // Below 640px the dialog is a bottom sheet, otherwise a centred modal.
    const sheet = window.innerWidth < 640;
    this._matDialog.open(SupportContactDialogComponent, {
      data: { email: this.user && this.user.usrEmail ? this.user.usrEmail : '' },
      width: sheet ? '100vw' : '560px',
      maxWidth: sheet ? '100vw' : '95vw',
      position: sheet ? { bottom: '0' } : undefined,
      autoFocus: 'first-tabbable',
      panelClass: sheet ? ['support-contact-dialog', 'support-contact-dialog--sheet'] : 'support-contact-dialog'
    });
  }

  logOut(): void {
    this.store$.dispatch(ProductActions.resetProducts());
    this._jwt.onLogOut();
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  chooseLang(event) {
    event.preventDefault();
  }

  onStopProp(event) {
    event.stopPropagation();
  }

  private history: string[] = [];

  back(): void {
    const currentUrl = this.router.url;

    // Check if we're on a report detail page
    if (currentUrl.startsWith('/reports/')) {
      // Navigate to reports list
      this.router.navigate(['/reports']);
      return;
    }

    this.history.pop();
    if (this.history.length > 0) {
      this.location.back()
    } else {
      this.router.navigateByUrl('/')
    }
  }

  changeLocation(id: any, name: any){
    this.store$.dispatch(UserActions.changeToken({ id: id, ids: [] }));
    //this.store$.dispatch(UserActions.changeToken({ id: this.selectedLocation[0], ids: this.selectedLocations }));
    setTimeout(() => {
      this.store$.dispatch(CoreActions.loadMe());
      this.store$.dispatch(SettingsActions.loadSettings());
      this.store$.dispatch(ImageActions.loadProfileImage());
      this.store$.dispatch(CountsActions.loadCounts({ active: 'invStartTS', direction: 'ASC', locations: this.selectedLocation  }));
      this.store$.dispatch(loadMostRecent());
      this.store$.dispatch(loadProducts({query:''}));
      this._imageUpload.onGetLogo();
      this._imageUpload.onGetReportLogo();
      locName$.next(name);
      this.localName$ = locName$;
      window.location.reload();
    }, 1000);
  }

  toggleSelectAll(): void {
    this.isAllSelected = !this.isAllSelected;
  
    if (this.isAllSelected) {
      this.selectedLocations = this.locationList.map(([id]) => +id);
    } else {
      this.selectedLocations = [];
    }
  }

  toggleLocation(id: number): void {
    const index = this.selectedLocations.indexOf(id);
    if (index > -1) {
      this.selectedLocations.splice(index, 1);
    } else {
      this.selectedLocations.push(Number(id));
    }
    //this.selectedLocations = this.selectedLocation;
  
    this.isAllSelected = this.selectedLocations.length === this.locationList.length;
  }

}
